import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectPartner360Files = createSelector(
  [selectConfigurationState],
  ({ data }) => data.files
)
